/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/AutomationTask/Title",
  onChange
  
}) {
let eventActionDataTitleValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.title',
})
let eventActionDataTitleChangeData = fromData.useDataChange({ viewPath,
context: 'event_action',
path: 'data.title',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 data="event_action.data.title"
 value={eventActionDataTitleValueData}
 onChange={eventActionDataTitleChangeData}
 required={true}
 marginTop={0}
 marginBottom={0}
 width="100%"
 label="Title"
 placeholder="Task title"
/>
{children}
</React.Fragment>)
}